import { IMaterial } from '@interfaces/IMaterial';
import { EMaterialsActions, MaterialsActions } from './materials.actions';
import { IMaterialsState, initialMaterialsState } from './materials.state';

export const materialsReducers = (
  state = initialMaterialsState,
  action: MaterialsActions
): IMaterialsState => {
  switch (action.type) {
    case EMaterialsActions.AddMaterial:
      return {
        ...state,
        loading: { ...state.loading, addMaterial: true },
        success: false,
      };
    case EMaterialsActions.AddMaterialSuccess:
      return {
        ...state,
        loading: { ...state.loading, addMaterial: false },
        materials: [...state.materials, action.material],
        success: true,
      };
    case EMaterialsActions.AddMaterialFailure:
      return {
        ...state,
        loading: { ...state.loading, addMaterial: false },
        success: false,
      };
    case EMaterialsActions.GetMaterial:
      return { ...state, loading: { ...state.loading, getMaterial: true } };
    case EMaterialsActions.GetMaterials:
      return { ...state, loading: { ...state.loading, getMaterials: true } };
    case EMaterialsActions.UpdateMaterial:
      return { ...state, loading: { ...state.loading, updateMaterial: true } };
    case EMaterialsActions.UpdateMaterialSuccess:
      return { ...state, loading: { ...state.loading, updateMaterial: false } };
    case EMaterialsActions.UpdateMaterialFailure:
      return { ...state, loading: { ...state.loading, updateMaterial: false } };
    case EMaterialsActions.GetMaterialSuccess:
      return {
        ...state,
        currentMaterial: action.material,
        loading: { ...state.loading, getMaterial: false },
      };
    case EMaterialsActions.GetMaterialsSuccess:
      return {
        ...state,
        materials: action.data.results,
        count: action.data.count,
        loading: { ...state.loading, getMaterials: false },
      };
    case EMaterialsActions.ClearMaterials:
      return { ...state, materials: [] };
    case EMaterialsActions.DeleteMaterial:
      return {
        ...state,
        success: false,
        loading: { ...state.loading, delete: true },
      };
    case EMaterialsActions.DeleteMaterialSuccess:
      return {
        ...state,
        success: true,
        loading: { ...state.loading, delete: false },
        materials: setMaterials(state.materials, action.material_id),
      };
    case EMaterialsActions.DeleteMaterialFailure:
      return {
        ...state,
        success: false,
        loading: { ...state.loading, delete: false },
      };
    case EMaterialsActions.ClearDeleteMaterialErrors:
      return { ...state, success: false };
    default:
      return { ...state };
  }
};

const setMaterials = (materials: IMaterial[], id: number): IMaterial[] => {
  const materialsCopy = [...materials];
  const index = materialsCopy.findIndex(m => m.id === id);
  materialsCopy.splice(index, 1);

  return materialsCopy;
};
